





































import Vue from "vue";
import { VList, VListItem, VListItemTitle, VListItemAction, VIcon, VListItemContent, VBadge } from "vuetify/lib";
import { defineComponent } from "@vue/composition-api";
import { MenuItems } from "@/types";
import { castComponent } from "@/lib/helpers";
import CheckAuthorities from "@/components/CheckAuthorities";

Vue.component("VList", castComponent(VList));
Vue.component("VListItem", castComponent(VListItem));
Vue.component("VListItemTitle", castComponent(VListItemTitle));
Vue.component("VListItemAction", castComponent(VListItemAction));
Vue.component("VIcon", castComponent(VIcon));
Vue.component("VListItemContent", castComponent(VListItemContent));
Vue.component("CheckAuthorities", castComponent(CheckAuthorities));
Vue.component("VBadge", castComponent(VBadge));

export default defineComponent({
  name: "BaseMenu",
  props: {
    menu: { type: Array as () => MenuItems, required: true },
  },
});
